import React, { Fragment } from 'react'
import Footer from '../../Components/Footer/Footer'
import Phone from '../../Components/Phone/Phone'

function PhoneLogin() {
  return (
    <Fragment>
        <Phone/>
        <Footer/>
    </Fragment>
  )
}

export default PhoneLogin